/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_ChannelInputs */

const vi_order_channel = /** @type {(inputs: Order_ChannelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kênh`)
};

/**

* @param {Order_ChannelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_channel = /** @type {((inputs?: Order_ChannelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_ChannelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_channel(inputs)
});